import {Injectable} from '@angular/core';
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AppInsightsService {
  public appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

  public logError(error: any, ...rest: any) {
    environment.production ? this.appInsights.trackException(error, rest) : console.error(error, ...rest);
  }

  public logTimeStamp(label: string, type: string = '', end: boolean = false) {
    environment.production
      ? this.appInsights.trackTrace({message: label}, {type: type, end: end})
      : (() => {
        const logLabel = `[SGDP Purchase Portal] ${type ? type + ' ' : ''}${label}`;
        if (end) {
          console.timeEnd(logLabel);
        } else {
          console.time(logLabel);
        }
        console.timeStamp();
      })();
  }
}
